export enum NotificationEnum {
  Notificacao = 'Notificacao',
  Mensagem = 'Mensagem',
  PesquisaSatisfacao = 'PesquisaSatisfacao',
  SaudeOnline = 'SaudeOnline',
}